import React from 'react';
import { HomeIcon, ShieldIcon, WalletIcon, FileTextIcon, MenuIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { TabType } from './BottomNav';
interface SideNavProps {
  activeTab: TabType;
  onChange: (tab: TabType) => void;
}
export function SideNav({
  activeTab,
  onChange
}: SideNavProps) {
  const tabs = [{
    id: 'dashboard',
    label: 'Home',
    icon: HomeIcon
  }, {
    id: 'products',
    label: 'Products',
    icon: ShieldIcon
  }, {
    id: 'wallet',
    label: 'Wallet',
    icon: WalletIcon
  }, {
    id: 'policies',
    label: 'My Plans',
    icon: FileTextIcon
  }, {
    id: 'profile',
    label: 'More',
    icon: MenuIcon
  }] as const;
  return <div className="w-64 h-full bg-[#0D3B3B] text-white flex flex-col shrink-0 border-r border-[#0D3B3B]/20 shadow-xl z-50" data-id="element-841">
      <div className="p-6 flex items-center gap-3 border-b border-white/10" data-id="element-842">
        <img src="https://cdn.magicpatterns.com/uploads/urMXFPH61J79xPimgGTTYX/Group_577.png" alt="Skydd" className="h-8 w-auto" data-id="element-843" />
      </div>

      <div className="flex-1 py-6 px-4 space-y-2 overflow-y-auto" data-id="element-844">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => onChange(tab.id)} className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-xl transition-all duration-300 relative ${isActive ? 'bg-[#FFD700] text-[#0D3B3B] shadow-lg shadow-[#FFD700]/10 font-bold' : 'text-white/70 hover:bg-white/10 hover:text-white font-medium'}`} data-id="element-845">
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} data-id="element-846" />
              <span className="text-sm" data-id="element-847">{tab.label}</span>
              {isActive && <motion.div layoutId="sideNavIndicator" className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-8 bg-[#0D3B3B] rounded-r-full" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-848" />}
            </button>;
      })}
      </div>

      <div className="p-6 border-t border-white/10" data-id="element-849">
        <div className="flex items-center gap-3 bg-white/5 p-3 rounded-xl border border-white/10" data-id="element-850">
          <div className="w-10 h-10 rounded-full bg-[#FFD700] flex items-center justify-center text-[#0D3B3B] font-black shrink-0" data-id="element-851">
            AO
          </div>
          <div className="overflow-hidden" data-id="element-852">
            <p className="text-sm font-bold truncate" data-id="element-853">Adaeze Okonkwo</p>
            <p className="text-xs text-white/50 truncate" data-id="element-854">Tier 2 Verified</p>
          </div>
        </div>
      </div>
    </div>;
}